import React from 'react';

const PatientsRequestSelected = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 11.5V5.5M7 8.5H13M5 16V18.3355C5 18.8684 5 19.1348 5.10923 19.2716C5.20422 19.3906 5.34827 19.4599 5.50054 19.4597C5.67563 19.4595 5.88367 19.2931 6.29976 18.9602L8.68521 17.0518C9.17252 16.662 9.41617 16.4671 9.68749 16.3285C9.9282 16.2055 10.1844 16.1156 10.4492 16.0613C10.7477 16 11.0597 16 11.6837 16H14.2C15.8802 16 16.7202 16 17.362 15.673C17.9265 15.3854 18.3854 14.9265 18.673 14.362C19 13.7202 19 12.8802 19 11.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V12C1 12.93 1 13.395 1.10222 13.7765C1.37962 14.8117 2.18827 15.6204 3.22354 15.8978C3.60504 16 4.07003 16 5 16Z"
        stroke="#73B1E9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NewPatientsRequestSelected = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 21.5V15.5M17.5 18.5H23.5M15.5 26V28.3355C15.5 28.8684 15.5 29.1348 15.6092 29.2716C15.7042 29.3906 15.8483 29.4599 16.0005 29.4597C16.1756 29.4595 16.3837 29.2931 16.7998 28.9602L19.1852 27.0518C19.6725 26.662 19.9162 26.4671 20.1875 26.3285C20.4282 26.2055 20.6844 26.1156 20.9492 26.0613C21.2477 26 21.5597 26 22.1837 26H24.7C26.3802 26 27.2202 26 27.862 25.673C28.4265 25.3854 28.8854 24.9265 29.173 24.362C29.5 23.7202 29.5 22.8802 29.5 21.2V15.8C29.5 14.1198 29.5 13.2798 29.173 12.638C28.8854 12.0735 28.4265 11.6146 27.862 11.327C27.2202 11 26.3802 11 24.7 11H16.3C14.6198 11 13.7798 11 13.138 11.327C12.5735 11.6146 12.1146 12.0735 11.827 12.638C11.5 13.2798 11.5 14.1198 11.5 15.8V22C11.5 22.93 11.5 23.395 11.6022 23.7765C11.8796 24.8117 12.6883 25.6204 13.7235 25.8978C14.105 26 14.57 26 15.5 26Z"
        stroke="#22CCEE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NewSelectedPatientsRequestSelected = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="40" height="40" rx="20" fill="#91bee7" />
      <path
        d="M20.5 21.5V15.5M17.5 18.5H23.5M15.5 26V28.3355C15.5 28.8684 15.5 29.1348 15.6092 29.2716C15.7042 29.3906 15.8483 29.4599 16.0005 29.4597C16.1756 29.4595 16.3837 29.2931 16.7998 28.9602L19.1852 27.0518C19.6725 26.662 19.9162 26.4671 20.1875 26.3285C20.4282 26.2055 20.6844 26.1156 20.9492 26.0613C21.2477 26 21.5597 26 22.1837 26H24.7C26.3802 26 27.2202 26 27.862 25.673C28.4265 25.3854 28.8854 24.9265 29.173 24.362C29.5 23.7202 29.5 22.8802 29.5 21.2V15.8C29.5 14.1198 29.5 13.2798 29.173 12.638C28.8854 12.0735 28.4265 11.6146 27.862 11.327C27.2202 11 26.3802 11 24.7 11H16.3C14.6198 11 13.7798 11 13.138 11.327C12.5735 11.6146 12.1146 12.0735 11.827 12.638C11.5 13.2798 11.5 14.1198 11.5 15.8V22C11.5 22.93 11.5 23.395 11.6022 23.7765C11.8796 24.8117 12.6883 25.6204 13.7235 25.8978C14.105 26 14.57 26 15.5 26Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PatientsRequestSelected;
